import { html, SYSConfig } from "../../../"
import { _TableRowEditFormType } from "../../../state"
import { _setDialogVisible } from "../../forms/helper"
import { SYSBaseElement } from "../../sysbaseelement"

import type { EditMode, EditRowDef, SYSTableData, SYSTableDef } from "../table"

export class SYSTableRowEditFormDialog extends SYSBaseElement {
  def: SYSTableDef
  data: SYSTableData
  key: string
  editMode: EditMode
  async init() {
    let tableRowEditState: _TableRowEditFormType = this.dialogState.data
    this.data = SYSConfig.app.tableDefIds[tableRowEditState.tableDefId].getData(
      this.state
    )
    this.def = this.data.tableDef[tableRowEditState.tableDefId]
    this.key = tableRowEditState.key
    this.editMode = tableRowEditState.editMode

    if (this.editMode !== "add") {
      if (this.data.data[this.key] === undefined) {
        throw new Error(
          `Error OpenTableRowEdit: TableDefId: ${tableRowEditState.tableDefId} Key ${this.key} not found in data`
        )
      }
    }
    if (!tableRowEditState.formInitialised) {
      switch (this.editMode) {
        case "edit":
          await this.actions.ovl.table._TableEditRow({
            data: this.data,
            def: this.def,
            key: this.key,
          })
          break
        case "add":
          let addRes = await this.actions.ovl.table._TableAddRow({
            data: this.data,
            def: this.def,
          })
          this.key = addRes.key
          await this.actions.ovl.table._TableEditRow({
            data: this.data,
            def: this.def,
            key: this.key,
            initialFocusFieldKey: addRes.fieldKeyToFocus,
          })

          break
        case "copy":
          let copyRes = await this.actions.ovl.internal._TableCopyRow({
            data: this.data,
            def: this.def,
            key: this.key,
          })
          this.key = copyRes.key
          await this.actions.ovl.table._TableEditRow({
            data: this.data,
            def: this.def,
            key: this.key,
            initialFocusFieldKey: copyRes.fieldKeyToFocus,
          })

          break
      }
    }

    await super.init()
  }

  async getUI() {
    if (!this.dialogState.data) {
      return null
    }
    if (!this.def || !this.def.initialised) {
      _setDialogVisible(false, this.dialogState)
      throw new Error(
        "please initialise underlying table first and make sure you open this dialog using OpenTableRowEditxxx - Actions"
      )
    }
    let row = this.data.data[this.key]
    // if (this.editMode != "edit") {
    //   this.key = this.def.uiState.currentlyAddingKey
    // }

    return html`
      <ovl-trowformb
        id=${"trow" + this.def.id + this.key}
        .props=${() => {
          return <EditRowDef>{
            tableDef: this.def,
            data: this.data,
            row: row,
            key: this.key,
            mode: this.editMode,
            DialogType: "SYSTableRowEdit",
          }
        }}
      >
      </ovl-trowformb>
    `
  }
}
